export default __webpack_public_path__ + "static/media/thesis_2026.a5bca450.pdf";